import { Navigate, RouteObject } from 'react-router-dom';

import { AppLayout, ProtectedRoute } from '@/components/layout';

import { AppraisalsPage, AppraisalDetailPage } from '@/pages/appraisals';
import { JobEndPage } from '@/pages/job-ends';
import { SettingsPage } from '@/pages/settings';
import {
  OCCerSearchPage,
  JobEndAdminPage,
  TalentCommitteesPage,
  TalentCommitteeRunPage,
  CalibrationMatrixPage,
  AppraisalAdminPage,
} from '@/pages/staffing-activities';
import { SkillsMatrixPage } from '@/pages/admin/skills-matrix';
import { DashboardPage } from '@/pages/DashboardPage';
import { LoginPage } from '@/pages/LoginPage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { NotRegisteredPage } from '@/pages/NotRegisteredPage';
import { UnauthorizedPage } from '@/pages/UnauthorizedPage';
import { ImpersonatePage } from '@/pages/admin/ImpersonatePage';
import { NotificationTemplatesPage } from '@/pages/admin/notification-templates/NotificationTemplatesPage';
import { NotificationTemplateEditPage } from '@/pages/admin/notification-templates/NotificationTemplateEditPage';
import {
  DesktopNotificationsPage,
  DesktopNotificationEditPage,
} from '@/pages/admin/desktop-notifications';
import { ManualJobEndPage } from '@/pages/admin/manual-job-end';
import { paths } from './paths';

export const routes: RouteObject[] = [
  {
    path: paths.login,
    element: <LoginPage />,
  },
  {
    path: paths.unauthorized,
    element: <UnauthorizedPage />,
  },
  {
    path: paths.notRegistered,
    element: <NotRegisteredPage />,
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <AppLayout />,
        children: [
          {
            path: paths.dashboard,
            element: <DashboardPage />,
          },
          {
            path: '/dashboard',
            element: <Navigate to={paths.dashboard} replace />,
          },
          {
            path: paths.appraisals,
            element: <AppraisalsPage />,
          },
          {
            path: paths.appraisalDetail,
            element: <AppraisalDetailPage />,
          },
          {
            path: paths.staffingActivities.talentCommittees,
            element: <TalentCommitteesPage />,
          },
          {
            path: paths.staffingActivities.talentCommitteeRun,
            element: <TalentCommitteeRunPage />,
          },
          {
            path: paths.staffingActivities.calibrationMatrix,
            element: <CalibrationMatrixPage />,
          },
          {
            path: paths.staffingActivities.appraisalAdmin,
            element: <AppraisalAdminPage />,
          },
          {
            path: paths.jobEnd,
            element: <JobEndPage />,
          },
          {
            path: paths.settings,
            element: <SettingsPage />,
          },
          {
            path: paths.staffingActivities.jobEndAdmin,
            element: <JobEndAdminPage />,
          },
          {
            path: paths.staffingActivities.occerSearch,
            element: <OCCerSearchPage />,
          },
          {
            path: paths.admin.impersonate,
            element: <ImpersonatePage />,
          },
          {
            path: paths.admin.notificationTemplates,
            element: <NotificationTemplatesPage />,
          },
          {
            path: paths.admin.notificationTemplateDetail,
            element: <NotificationTemplateEditPage />,
          },
          {
            path: paths.admin.desktopNotifications,
            element: <DesktopNotificationsPage />,
          },
          {
            path: paths.admin.desktopNotificationDetail,
            element: <DesktopNotificationEditPage />,
          },
          {
            path: paths.admin.skillsMatrix,
            element: <SkillsMatrixPage />,
          },
          {
            path: paths.admin.manualJobEnd,
            element: <ManualJobEndPage />,
          },
        ],
      },
    ],
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export { paths };
